'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getStructuredData = getStructuredData;

var _lodash = require('lodash');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStructuredData(_ref) {
  var community = _ref.community;

  return {
    '@bdType': 'Community',
    '@context': 'http://schema.org',
    '@type': ['Place'],
    additionalType: ['http://www.productontology.org/id/Subdivision_(land)'],
    name: (0, _lodash.get)(community, 'name'),
    description: (0, _lodash.get)(community, 'description'),
    address: (0, _extends3.default)({}, (0, _lodash.get)(community, 'address'), { order: undefined }),
    geo: {
      '@type': 'GeoCoordinates',
      latitude: (0, _lodash.get)(community, 'geoIndexed[1]'),
      longitude: (0, _lodash.get)(community, 'geoIndexed[0]')
    }
  };
}

function CommunityConstructor(props) {
  var builder = props.builder,
      community = props.community;

  var title = (0, _lodash.get)(community, 'name') + ' | ' + (0, _lodash.get)(community, 'address.addressLocality') + ' ' + (0, _lodash.get)(community, 'address.addressRegion') + ' New Home Community | ' + builder.name;

  var elements = {
    'ld+json': [getStructuredData(props)],
    title: {
      content: (0, _lodash.get)(community, 'metaTags.title', title),
      attrs: {}
    },
    meta: [{
      name: 'description',
      content: (0, _lodash.get)(community, 'metaTags.description', (0, _lodash.get)(community, 'description'))
    }, {
      property: 'og:image',
      content: (0, _bdcoreUtilities.buildThumbnailUrl)((0, _lodash.get)(community, 'photos[0].contentUrl'), { width: 1200, height: 1200 })
    }, {
      property: 'og:title',
      content: (0, _lodash.get)(community, 'metaTags.title', title)
    }, {
      property: 'og:description',
      content: (0, _lodash.get)(community, 'metaTags.description', (0, _lodash.get)(community, 'description'))
    }]
  };

  return elements;
}

exports.default = CommunityConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-pagehelmet/build/Community.js
// module id = 511
// module chunks = 0